import { Injectable } from "@angular/core";
import { PromiseLookupService } from "../../impl/PromiseLookupService";
import { ICurrencyPairCalendarPromiseLookupService } from "../ICurrencyPairCalendarPromiseLookupService";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { Observable } from "rxjs";

export abstract class CurrencyPairCalendarPromiseLookupService
  extends PromiseLookupService<string, CubiqTS.CurrencyPairCalendarImpl>
  implements ICurrencyPairCalendarPromiseLookupService
{
  constructor() {
    super();
  }

  public abstract requestRun(ccyPairs: Array<string> | null): Promise<CubiqTS.CurrencyPairCalendar>;
  public abstract getTdrNotification(): Observable<Set<string>>;
  public abstract getCalendarWithHolidays(
    base: string,
    nonBase: string,
    product: CubiqTS.Product,
  ): Promise<CubiqTS.CurrencyPairCalendar>;
  public abstract getFixingDate(base: string, nonBase: string, brokenDate: Date): Promise<Date>;
}
